window.onload = (event) => {

  // Function that takes answers and saves them to local storage
  // react to selection
  document.querySelectorAll('.answer').forEach(
    element => element.addEventListener('click', function(event){
      event.target.parentElement.querySelectorAll('.answer.active').forEach( e => e.classList.remove('active'));
      event.target.classList.add('active');
      if (document.querySelectorAll('.answer.active').length > 5){
        document.getElementById('shindann__result').removeAttribute("disabled")
        document.getElementById('shindann__result').classList.remove("disabled")
      }
    })
  )

  document.getElementById('shindann__result').addEventListener('click', function(event){
    const score = [0,0,0]
    const answers = document.querySelectorAll('.answer.active')
    answers.forEach(function(element){
      score[0] += parseInt(element.dataset['scoreMv']);
      score[1] += parseInt(element.dataset['scoreCf']);
      score[2] += parseInt(element.dataset['scoreEg']);
    })
    console.log('mv',score[0],'cf',score[1],'eg',score[2])

    getUrl = function(score){
      if ( score[0] > 0){
        if (score[1] > 0){
          if (score[2] > 0){
            // Modern x Casual x Economy
            return '/pages/diagnosis-local'
          }else {
            // Modern x Casual x Gorgeous
            return '/pages/diagnosis-urbanmode'

          }
        }else {
          if (score[2] > 0){
            // Modern x Formal x Economy
            return '/pages/diagnosis-work'

          }else {
            // Modern x Formal x Gorgeous
            return '/pages/diagnosis-formal'

          }
        }
      }else {
        if (score[1] > 0){
          if (score[2] > 0){
            // Vintage x Casual x Economy
            return '/pages/diagnosis-chill'

          }else {
            // Vintage x Casual x Gorgeous
            return '/pages/diagnosis-hipster'
          }
        }else {
          if (score[2] > 0){
            // Vintage x Formal x Economy
            return '/pages/diagnosis-almighty'

          }else {
            // Vintage x Formal x Gorgeous
            return '/pages/diagnosis-weekend'
          }
        }
      }
    };
    let langModifier = window.location.href.includes('/en/') ? '/en' : window.location.href.includes('/zh/') ? '/zh' : '';
    window.location = langModifier + getUrl(score);
  })
}